// extracted by css-extract-rspack-plugin
export default {"item":"src-wab-client-components-modals-SiteDiffs-module__item-qvWqHN","headerItem":"src-wab-client-components-modals-SiteDiffs-module__headerItem-rmRUIs"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"item\":\"src-wab-client-components-modals-SiteDiffs-module__item-qvWqHN\",\"headerItem\":\"src-wab-client-components-modals-SiteDiffs-module__headerItem-rmRUIs\"}";
        // 1793541990640
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  